module.exports = __webpack_public_path__ + "assets/img/solutions4.afd7125f.png";